// extracted by mini-css-extract-plugin
export default {"card":"indicatorsCardsGroup_card__C3P04","container":"indicatorsCardsGroup_container__HOgfg"};